import { observable } from 'mobx';

import { Variables, ConnectionAppManager, AppRegistry } from 'core/index';

import { NotificationsApp } from 'apps/notificationCenter/app';
import { ProfileProjectsQuery } from 'apps/project/gql';

export class NotificationConnManager extends ConnectionAppManager {
  static registryName = 'NotificationConnManager';
  static ArrayApp = NotificationsApp;
  @observable sortBy;
  @observable sortOptions;
  constructor(parent, init) {
    super(parent, init);
    this.sortBy = init.sortBy || 'recent';
    this.filterBy = init.filterBy || [];
    this.contains = init.contains || [];
    this.variables = new Variables({
      sortBy: () => this.sortBy,
      count: () => (this.loadedMore ? this.batchSize : this.initialBatchSize),
      cursor: () => this.endCursor,
      filterBy: () => this.filterBy,
      contains: () => this.contains,
    });
    this.loadMoreQuery = init.loadMoreQuery || ProfileProjectsQuery;
  }
}
AppRegistry.add(NotificationConnManager);
